<template>
    <div class="download-index">
        <div class="download">
            <banHead :bannerHead="banHead"></banHead>
        </div>
        <section>
            <div class="download-cont center">
                <ul>
                    <li class="clearfix" v-for="(item,index) in sectionInfo" :key="index" @click="clickMore(index)">
                        <div class="down-top">
                            <span class="common-font">{{item.name}}</span>
                            <router-link to="">Download<i></i></router-link>
                        </div>
                        <span class="down-icon"
                              :style="{'background-image':'url('+item.downIcon+')'}" :_src="item.downIcon1"></span>
                    </li>
                </ul>
                <div class="learn-more">
                    <span class="down-mes">For product usage or other problems, you can quickly visit Q&A to answer questions.</span>
                    <a href="https://sensoro.zendesk.com/hc/en-us">Access to Q&A</a>
                </div>
            </div>
        </section>
        <div class="click-more"  v-show="showNote" @click="closeOne">
            <div class="more-box" v-for="(item,index) in sectionInfo" :index="index" v-show="index === activedKey">
                <h1>{{item.name}}</h1>
                <div class="phone-pc">
                    <ul>
                        <li>
                            <a :href="item.iosDown">IOS</a>
                        </li>
                        <li v-if="item.androidDown">
                            <a :href="item.androidDown">Android</a>
                        </li>
                    </ul>
                    <img :src="item.url" alt="" v-if="item.url">
                    <div class="close-btn" @click="closeMore"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import banHead from '../common/banHead'

    export default {
        name: "download",
        data() {
            return {
                activedKey: -1,
                showNote: false,
                banHead: {
                    title: 'Download',
                    msg: 'This section includes all the tool Apps, developer documents and media kits. Please download according to your need.',
                    _src: '/static/image/download/download-bannner@2x.jpg'
                },
                sectionInfo: [
                    {
                        name: 'Config Tool',
                        downIcon: '/static/image/download/Config_Tool@1x.png',
                        downIcon1: '/static/image/download/Config_Tool@2x.png',
                        url: '/static/image/download/download_erweima.png',
                        iosDown: 'https://itunes.apple.com/cn/app/sensoro-yun-zi-pei-zhi/id902437077?mt=8',
                        androidDown: 'http://fir.sensoro.com/yunzi',
                    },
                    {
                        name: 'Inspect Tool',
                        downIcon: '/static/image/download/Function@1x.png',
                        downIcon1: '/static/image/download/Function@2x.png',
                        url: '/static/image/download/download_erweima.png',
                        iosDown: 'https://itunes.apple.com/cn/app/sensoro-xun-jian-gong-ju/id1053345914?mt=8',
                        androidDown: 'http://sensoro.github.io/download/app/sensoro-beacon-inspection/android/SensoroInspection.apk',
                    },
                    {
                        name: 'SDK',
                        downIcon: '/static/image/download/SDK@1x.png',
                        downIcon1: '/static/image/download/SDK@2x.png',
                        iosDown: 'https://github.com/Sensoro/SDK-iOS',
                        androidDown: 'https://github.com/Sensoro/SDK-Android',
                    },
                    {
                        name: 'Deployment Tool',
                        downIcon: '/static/image/download/Deployment_Tool@1x.png',
                        downIcon1: '/static/image/download/Deployment_Tool@2x.png',
                        iosDown: 'https://itunes.apple.com/cn/app/sensoro-bu-shu-gong-ju/id1061844253?mt=8',
                    }
                ],

            }
        },
        created() {

        },
        methods: {
            clickMore(key) {
                // console.log(key);
                /*             var ToolIndex = this.$refs.click1.children;
                             if (ToolIndex[key]) {
                                 this.showNote = true;
                                 this.sectionInfo[key].showIndex = true;
                             }*/
                this.showNote = true;
                this.activedKey = key;
            },
            closeOne(e) {
                console.log(e.target.className);
                if (e.target.className === 'click-more') {
                    this.showNote = false;
                    this.activedKey = -1
                }


            },
            closeMore() {
                this.showNote = false;
            }
        },
        mounted() {
            this.utils.getImg();
        },
        components: {
            banHead
        }
    }
</script>

<style lang="less">
    .download-index {
        width: 100%;
        position: relative;
        @baseWidth: 1640px;

        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        .common-font{
            font-family: 'Gotham-Medium',"Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        /*banner*/
        .download {
            width: 100%;
            /*banner*/
            .com-banner {
                background: url("/static/image/download/download-bannner@1x.jpg") no-repeat center;
                .banner-pro p {
                    width: 660px;
                }
            }

        }
        section {
            .download-cont {
                margin: 94px auto 0;
                padding-bottom: 96px;
                ul {
                    display: flex;
                    justify-content: space-between;
                    li {
                        width: 380px;
                        height: 250px;
                        background: #fafafa;
                        padding: 33px 40px 40px 31px;
                        transition: all .3s;
                        .down-top {
                            float: left;
                            color: #252525;
                            width: 100%;
                            margin-bottom: 23px;
                            span {
                                display: block;
                                font-size: 24px;
                                line-height: 42px;
                                margin-bottom: 8px;
                            }
                            a {
                                color: #252525;
                                font-size: 14px;
                                line-height: 22px;
                                i {
                                    display: inline-block;
                                    background: url("/static/image/download/download@1x.png") no-repeat center;
                                    width: 12.7px;
                                    height: 12.5px;
                                    margin-left: 6px;
                                }
                            }
                        }
                        .down-icon {
                            float: right;
                            display: block;
                            width: 85px;
                            height: 83px;
                            background-size: cover;
                        }
                        &:hover {
                            background: #000;
                            transition: all .3s;
                            .down-top {
                                color: #fff;
                                a {
                                    color: #fff;
                                    i {
                                        background: url("/static/image/download/download_hover@2x.png") no-repeat center;
                                        background-size: cover;
                                    }
                                }
                            }
                            &:nth-child(1) .down-icon {
                                background: url("/static/image/download/Config_Tool@hover@1x.png") no-repeat center !important;
                                background-size: cover;
                            }
                            &:nth-child(2) .down-icon {
                                background: url("/static/image/download/Function_hover@1x.png") no-repeat center !important;
                                background-size: cover;
                            }
                            &:nth-child(3) .down-icon {
                                background: url("/static/image/download/SDK_hover@1x.png") no-repeat center !important;
                                background-size: cover;
                            }
                            &:nth-child(4) .down-icon {
                                background: url("/static/image/download/Deployment_Tool_hover@1x.png") no-repeat center !important;
                                background-size: cover;
                            }

                        }
                    }
                }
                span.down-mes {
                    display: block;
                    margin-top: 96px;
                    margin-bottom: 17px;
                    font-size: 16px;
                    color: #5D5D5D;
                    line-height: 26px;
                }
                a {
                    font-size: 14px;
                    /*font-weight: bold;*/
                    color: #252525;
                    line-height: 22px;
                    text-decoration: underline;
                }
            }
        }
        .click-more {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, .5);

            .more-box {
                position: fixed;
                left: 50%;
                top: 50%;
                margin-left: -200px;
                margin-top: -100px;
                width: 472px;
                height: 281px;
                background: #fff;
                padding: 32px 64px;
                &:nth-child(3) {
                    .phone-pc ul {
                        width: 100%;
                        /*display: inline-block;*/
                        /*float: left;*/
                        display: flex;
                        align-items: center;
                        justify-items: center;
                    }
                }
                &:nth-child(4) {
                    .phone-pc ul {
                        width: 100%;
                        li {
                            margin: 50px auto 0;
                            /*margin-top: 50px;*/
                        }
                    }
                }
                .close-btn {
                    position: absolute;
                    right: 16px;
                    top: 16px;
                    width: 16px;
                    height: 16px;
                    background: url("/static/image/download/close-btn@1x.png") no-repeat center;
                }
                h1 {
                    text-align: center;
                    font-size: 28px;
                    color: #252525;
                    line-height: 42px;
                    margin-bottom: 21px;
                }
                .phone-pc {
                    display: flex;
                    justify-content: space-between;
                    img {
                        width: 140px;
                        height: 140px;
                    }
                    ul {
                        li {
                            a {
                                display: inline-block;
                                text-decoration: none;
                                font-size: 14px;
                                width: 100%;
                                height: 100%;
                                color: #252525;
                                text-align: center;
                                line-height: 58px;
                                &:hover{
                                    background: #252525;
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
                ul {
                    height: 141px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    li {
                        width: 180px;
                        height: 58px;
                        line-height: 58px;
                        text-align: center;
                        font-size: 14px;
                        color: #252525;
                        border: 1px solid #252525;
                    }

                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth:1256px;
        .download-index {
            width: 100%;
            min-width: @autoWidth;
            /*padding-bottom: 400px;*/
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            section {
                .download-cont {
                    width: 800px;
                    ul {
                        flex-wrap: wrap;
                        li {
                            margin-bottom: 60px;
                        }
                    }
                    span.down-mes {
                        margin-top: 0px;
                    }
                }
            }
            .click-more {

                .more-box {
                    position: fixed;
                    left: 50%;
                    top: 50%;
                    margin-left: -230px;
                    margin-top: -140px;
                    width: 472px;
                    height: 281px;
                    background: #fff;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/download.vue